/**
 * Download sustainability report
 * For: sustainability reporting > reports > download report button
 */

import { getToken } from "../../utils";
import { BASE_URL } from "../../endpoints";

export type Zfiletype =
  | "report_excel"
  | "draft_report_excel";

interface IGetDownloadReport {
  type: Zfiletype;
  taxYear?: number;
}

const fileurlmappings = {
  report_excel: "export_sustainability_zip_report",
  draft_report_excel: "export_sustainability_zip_report_draft",
};

const getDownloadZipReport = async ({ type, taxYear }: IGetDownloadReport) => {
  const token = getToken();
  const urlSuffix = fileurlmappings[type];
  if (token) {
    try {
      const response = await fetch(
        `${BASE_URL}/api/sustainability_reports/${urlSuffix}?tax_year=${taxYear}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        }
      );

      if (response.status === 200) {
        const data = await response.blob();
        return data;
      } else {
        return null;
      }
    } catch {
      return null; // network error
    }
  } else {
    return null; // No token
  }
};

export default getDownloadZipReport;
